<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">계약관리</span>
            <span class="txt">핏투데이케어에 가입한 업체 계약 및 결제정보 등록, 수정, 삭제가 가능합니다.</span>
        </div>

        <div class="com-table-top">
            <span class="title">연장결제</span>
        </div>
        <div class="com-table-wrap">
            <span class="top-title"><span class="title">계약정보</span></span>
            <div class="info-edit-table">
                <div class="table-wrapper">
                    <table>
                        <colgroup>
                            <col style="width: 156px" />
                            <col style="width: auto" />
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>
                                    센터
                                    <span class="imp">*</span>
                                </th>
                                <td>
                                    <input :value="centerInfo.centerName" class="w400" disabled type="text" />
                                </td>
                            </tr>
                            <!-- 연장할 상품이 프로그램인 경우 -->
                            <tr v-if="isProgramProduct">
                                <th>상품</th>
                                <td>
                                    <select-form
                                        :select-data="['선택', ...editField.program.names]"
                                        :select-value="['', ...editField.program.values]"
                                        :selected-value="selectedProgramId"
                                        class="w240"
                                        @update:set="(val) => (selectedProgramId = val)"
                                    ></select-form>
                                    <table class="sub-table">
                                        <colgroup>
                                            <col style="width: 150px" />
                                            <col style="width: auto" />
                                        </colgroup>
                                        <tbody>
                                            <tr>
                                                <th>사용기간</th>
                                                <td>
                                                    <div class="com-calendar-wrap">
                                                        <single-calendar
                                                            :start-date="editField.program.startDate"
                                                            @update="onUpdateProgramStartDate"
                                                        ></single-calendar>
                                                        <div class="com-dash"><span class="dash">~</span></div>
                                                        <single-calendar
                                                            :end-date="editField.program.endDate"
                                                            disabled
                                                        ></single-calendar>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>계약금액</th>
                                                <td>
                                                    <input
                                                        v-model="editField.program.price"
                                                        class="w130"
                                                        type="text"
                                                        @keypress="isNumber($event)"
                                                        @keyup="onKeyUpProgramPrice"
                                                    />
                                                    <span class="txt">원</span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                            <!-- 프로그램 상품 끝 -->
                            <!-- 연장할 상품이 문자서비스인 경우 -->
                            <tr v-if="isMmsProduct">
                                <th>상품</th>
                                <td>
                                    <select-form
                                        :select-data="['선택', ...editField.mms.values]"
                                        :select-value="['', ...editField.mms.values]"
                                        :selected-value="selectedMmsPeriod"
                                        class="w240"
                                        @update:set="(val) => (selectedMmsPeriod = val)"
                                    ></select-form>
                                    <table class="sub-table">
                                        <colgroup>
                                            <col style="width: 150px" />
                                            <col style="width: auto" />
                                        </colgroup>
                                        <tbody>
                                            <tr>
                                                <th>사용기간</th>
                                                <td>
                                                    <div class="com-calendar-wrap">
                                                        <single-calendar
                                                            :start-date="editField.mms.startDate"
                                                            @update="onUpdateMmsDate"
                                                        ></single-calendar>
                                                        <div class="com-dash"><span class="dash">~</span></div>
                                                        <single-calendar
                                                            :end-date="editField.mms.endDate"
                                                            disabled
                                                            @update="onUpdateMmsEndDate"
                                                        ></single-calendar>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>계약금액</th>
                                                <td>
                                                    <input
                                                        :value="editField.mms.price | numberFormatFilter"
                                                        class="w130"
                                                        disabled
                                                        type="text"
                                                    />
                                                    <span class="txt">원</span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <th>계약일</th>
                                <td>
                                    <single-calendar
                                        :start-date="editField.contractDate"
                                        @update="onUpdateContractDate"
                                    ></single-calendar>
                                </td>
                            </tr>
                            <!-- 문자서비스 상품 끝 -->
                        </tbody>
                    </table>
                </div>
                <div class="com-card-form">
                    <div class="top-area">
                        <div class="line">
                            <!--
                            <span class="count"><span class="txt">{{ editField.program.info.f_namee }}</span> <span class="num">{{ editField.program.price | numberFormatFilter }}</span> 원</span>
                            <span class="count" v-if="editField.mms.selectedValue !== ''"><span class="txt">문자서비스 {{ editField.mms.selectedValue }}개월</span> <span class="num">{{ editField.mms.price | numberFormatFilter }}</span> 원</span>
                            <span class="count" v-for="item in editField.additional"><span class="txt">{{ item.f_namee }}</span> <span class="num">{{ item.f_price | numberFormatFilter }}</span> 원</span>
                            -->

                            <span v-if="editField.program.selectedId !== ''" class="txt">
                                {{ editField.program.info.f_namee }} :
                                <span class="num">{{ editField.program.price | numberFormatFilter }}</span>
                                <span class="txt">원</span>
                            </span>
                            <span v-if="editField.mms.selectedValue !== ''" class="txt">
                                문자서비스 {{ editField.mms.selectedValue }}개월 :
                                <span class="num">{{ editField.mms.price | numberFormatFilter }}</span>
                                <span class="txt">원</span>
                            </span>
                        </div>
                        <div class="line">
                            <span class="txt">총 결제금액 :</span>
                            <span class="input-box">
                                <input :value="totalPrice | numberFormatFilter" class="w220" disabled type="text" />
                                <span class="txt">원</span>
                            </span>
                        </div>
                    </div>
                    <div class="middle-area">
                        <!-- 결제 정보 -->
                        <payment-info
                            v-for="(b, index) in editField.bills"
                            :key="index"
                            :bill-data="b"
                            :index="index"
                            :is-use-mileage="false"
                            :is-use-mileage-btn="false"
                            :is-use-receipt="false"
                            v-on:on-change="onChangePaymentFields"
                            v-on:on-click-delete="onClickDeletePaymentFields"
                        />

                        <div class="com-send-btn">
                            <button class="com-btn blue" @click="onClickAddPayment">결제정보추가</button>
                        </div>
                    </div>
                </div>
                <div class="bottom-btn">
                    <button class="com-btn" @click="onClickCancel">취소</button>
                    <button class="com-btn blue" @click="onClickExtend">등록</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import moment from 'moment';

export default {
    name: 'businessContractExtension',
    props: {},
    watch: {
        selectedProgramId(newVal, oldVal) {
            if (newVal !== oldVal) {
                const { program } = this.editField;
                program.selectedId = newVal;
                this.updateProgramInfo(newVal);
            }
        },
        selectedMmsPeriod(newVal, oldVal) {
            if (newVal !== oldVal) {
                const { mms } = this.editField;
                mms.selectedValue = newVal;
                this.updateMmsInfo();
            }
        },
    },
    computed: {
        today() {
            return moment().format('YYYY-MM-DD');
        },
        isProgramProduct() {
            return this.prevProduct.ftProductType === 'P';
        },
        isMmsProduct() {
            return this.prevProduct.ftProductType === 'M';
        },
        totalPrice() {
            if (this.isProgramProduct) {
                return this.getPureNumber(this.editField.program.price);
            } else if (this.isMmsProduct) {
                return this.getPureNumber(this.editField.mms.price);
            }
            return 0;
        },
        totalPrePrice() {
            if (this.isProgramProduct) {
                return this.editField.program.info.f_price;
            } else if (this.isMmsProduct) {
                return parseInt(this.editField.mms.selectedValue) * this.product.mms.f_price;
            }
            return 0;
        },
    },
    data() {
        return {
            contractId: parseInt(this.$route.params.contractId),
            productId: parseInt(this.$route.params.productId),
            contractInfo: {},
            centerInfo: {},
            prevProduct: {},
            selectedProgramId: '',
            selectedMmsPeriod: '',
            product: {
                program: {},
                mms: {},
                additional: [],
            },
            editField: {
                contractDate: '',
                program: {
                    selectedId: '',
                    info: {},
                    names: [],
                    values: [],
                    startDate: '',
                    endDate: '',
                    price: '',
                    name: '',
                },
                mms: {
                    selectedValue: '',
                    values: [],
                    startDate: '',
                    endDate: '',
                    price: '',
                },
                bills: [],
            },
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            // init values
            const { today, editField } = this;
            editField.contractDate = today;
            editField.mms.values = Array.from({ length: 24 }, (_, i) => (i + 1).toString());

            await this.getProductList();
            await this.getContractInfo();
            await this.getCenterInfo();

            this.addBills();
        },
        async getProductList() {
            try {
                const { data } = await this.sendGetFtProduct();
                this.reorganizeProduct(data);
            } catch (error) {
                alert('오류가 발생했습니다.');
                console.log('===> Failed init page : ', error);
                // console.log(centerData);
            }
        },
        reorganizeProduct(data) {
            // 데이터를 각각의 상품 데이터에 입력
            const { product } = this;
            const { names, values } = this.editField.program;

            for (const d of data) {
                switch (d.f_prod_type_cd) {
                    case 'P': // 프로그램
                        product.program[d.f_id] = { ...d };
                        names.push(d.f_namee);
                        values.push(d.f_id.toString());
                        break;
                    case 'M': // 문자서비스
                        product.mms = d;
                        break;
                    case 'B': // 부가서비스
                        product.additional.push(d);
                        break;
                }
            }
        },
        sendGetFtProduct() {
            return api.get('/admin/api/ft/product', {
                params: {},
            });
        },
        async getContractInfo() {
            try {
                const { data } = await this.sendGetFtContract();
                this.contractInfo = data;

                // 연장 상품 선택
                const { ftContractProducts } = data;
                for (const p of ftContractProducts) {
                    if (this.productId == p.ftProductId) {
                        this.prevProduct = p;
                        break;
                    }
                }

                if (this.isProgramProduct) {
                    // 연장할 상품이 프로그램인 경우, 동일한 상품을 선택 처리
                    this.selectedProgramId = this.productId.toString();
                    this.updateProgramInfo(this.selectedProgramId);
                } else if (this.isMmsProduct) {
                    // 연장할 상품이 문자서비스인 경우, 동일한 개월수 선택 처리
                    this.selectedMmsPeriod = this.prevProduct.contractMonth.toString();
                    this.updateMmsInfo();
                }

                console.log('===> Success Loading contractInfo: ', data);
            } catch (error) {
                console.log(error);
                alert('오류가 발생했습니다.');
            }
        },
        sendGetFtContract() {
            return api.get(`/admin/api/ft/contract/${this.contractId}`);
        },
        async getCenterInfo() {
            try {
                const { data } = await this.sendGetCenter();
                this.centerInfo = data;
                console.log('===> Success Loading centerInfo: ', data);
            } catch (error) {
                console.log(error);
                alert('오류가 발생했습니다.');
            }
        },
        sendGetCenter() {
            return api.get(`/admin/api/center/${this.contractInfo.centerId}`);
        },
        updateProgramInfo(id) {
            const { program } = this.editField;

            if (id === '') {
                program.selectedId = '';
                program.version = '';
                program.info = {};
                program.startDate = '';
                program.endDate = '';
                program.price = '';
                program.name = '';

                return;
            }

            const { product } = this;
            const programInfo = product.program[id];

            program.info = programInfo;
            program.price = this.getNumberFormat(programInfo.f_price);

            if (program.startDate === '') {
                program.startDate = this.today;
            }

            program.endDate = moment(program.startDate)
                .add({ months: programInfo.f_use_period })
                .subtract({ days: 1 })
                .format('YYYY-MM-DD');
        },
        updateMmsInfo() {
            const { mms } = this.editField;

            if (mms.selectedValue === '') {
                mms.selectedValue = '';
                mms.startDate = '';
                mms.endDate = '';
                mms.price = '';

                return;
            }

            const { product } = this;
            const mmsInfo = product.mms;

            if (mms.startDate === '') {
                mms.startDate = this.today;
            }

            mms.endDate = moment(mms.startDate)
                .add({ months: parseInt(mms.selectedValue) })
                .subtract({ days: 1 })
                .format('YYYY-MM-DD');
            mms.price = this.getNumberFormat(
                mms.selectedValue !== '' ? mmsInfo.f_price * parseInt(mms.selectedValue) : 0
            );
        },
        onUpdateProgramStartDate(d) {
            const { program } = this.editField;
            const { product } = this;

            program.startDate = d;

            if (program.selectedId !== '') {
                const programInfo = product.program[program.selectedId];
                program.endDate = moment(program.startDate)
                    .add({ months: programInfo.f_use_period })
                    .subtract({ days: 1 })
                    .format('YYYY-MM-DD');
            }
        },
        onUpdateMmsDate(d) {
            const { mms } = this.editField;
            mms.startDate = d;

            if (mms.selectedValue !== '') {
                mms.endDate = moment(mms.startDate)
                    .add({ months: parseInt(mms.selectedValue) })
                    .subtract({ days: 1 })
                    .format('YYYY-MM-DD');
            }
        },
        onUpdateMmsEndDate(d) {
            this.editField.mms.endDate = d;
        },
        onUpdateContractDate(d) {
            this.editField.contractDate = d;
        },
        addBills() {
            this.editField.bills.push({
                centerId: this.centerInfo.id,
                billPrice: 0,
                payType: 'C',
                payCardType: '',
                payBankType: '',
            });
        },
        onClickAddPayment() {
            this.addBills();
        },
        onChangePaymentFields(params) {
            const { data, index } = params;
            this.editField.bills[index] = { ...data };
        },
        onClickDeletePaymentFields(index) {
            this.$delete(this.editField.bills, index);
        },
        onKeyUpProgramPrice() {
            const num = this.getPureNumber(this.editField.program.price);
            this.editField.program.price = this.getNumberFormat(num);
        },
        onKeyUpMmsPrice() {
            const num = this.getPureNumber(this.editField.mms.price);
            this.editField.mms.price = this.getNumberFormat(num);
        },
        getPureNumber(num) {
            num = num === '' ? 0 : num;
            return parseInt(num.toString().replace(/[,-]/g, ''));
        },
        getNumberFormat(num) {
            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        isNumber(evt) {
            evt = evt || window.event;
            const charCode = evt.which ? evt.which : evt.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        // 등록 관련
        validateValues() {
            const { editField } = this;

            return true;
        },
        onClickExtend() {
            if (!this.validateValues()) {
                return false;
            }

            if (!confirm('연장하시겠습니까?')) {
                return false;
            }

            this.extendContract();
        },
        async extendContract() {
            try {
                const { data } = await this.sendFtContractExtend();
                alert('계약이 연장되었습니다.');

                this.$router.push({ path: `/madmin/business/contract/detail/${this.contractInfo.centerId}` });
            } catch (error) {
                console.log(error);
                alert('오류가 발생했습니다.');
            }
        },
        sendFtContractExtend() {
            const params = this.getParams();
            return api.post('/admin/api/ft/contract/extend', {
                ...params,
            });
        },
        getParams() {
            // const { bizNo, center, staff, contractDate, program, mms, additional } = this.editField;

            const { centerId, contractStaffId, contractName, contractTelNo, bizType, bizNo } = this.contractInfo;
            const { contractDate, program, mms } = this.editField;

            const params = {
                centerId,
                contractStaffId,
                contractName,
                contractTelNo,
                bizType,
                bizNo,
                contractedAt: contractDate,
                contractTotalPrice: this.totalPrice,
                contractPrePrice: this.totalPrePrice,
                memo: '',
                products: [],
                bills: [], // 결제정보 : 미구현
            };

            // 프로그램 정보 입력
            if (this.isProgramProduct) {
                params.products.push({
                    id: parseInt(program.selectedId),
                    version: program.info.f_ft_prod_ver,
                    contractStartDate: program.startDate,
                    contractEndDate: program.endDate,
                    contractMonth: program.info.f_use_period,
                    ftProductBuyPrice: this.getPureNumber(program.price),
                });
            }

            if (this.isMmsProduct) {
                const mmsInfo = this.product.mms;
                params.products.push({
                    id: mmsInfo.f_id,
                    version: mmsInfo.f_ft_prod_ver,
                    contractStartDate: mms.startDate,
                    contractEndDate: mms.endDate,
                    contractMonth: parseInt(mms.selectedValue),
                    ftProductBuyPrice: this.getPureNumber(mms.price),
                });
            }

            const billSeq = 0;
            for (const b of this.editField.bills) {
                params.bills.push({
                    centerId,
                    billSeq,
                    billPrice: this.getPureNumber(b.billPrice),
                    billDate: b.billDate,
                    payType: b.payType,
                    payCardType: b.payCardType,
                    payBankType: b.payBankType,
                });
            }

            return params;
        },
        onClickCancel() {
            this.$router.push({ path: `/madmin/business/contract/detail/${this.contractInfo.centerId}` });
        },
    },
};
</script>
<style lang="scss"></style>
